import { put, select } from 'redux-saga/effects'
import Loader from '../../loader'
import Zoid from '../../zoid'

export default function* watchInvalidationEvent({
    scope: scopes = [],
    shortCode,
}) {
    const {
        publisherId,
        adBlockDetector,
        content,
    } = yield select(Zoid.selectors.getXprops)

    const adBlocking = yield adBlockDetector()

    const requestPayload = {
        ...content,
        adBlocking,
    }

    /* eslint-disable-next-line no-restricted-syntax */
    for (const scope of scopes) {
        yield put(Loader.creators.getLoader({
            scope,
            shortCode,
            publisherId,
            requestPayload,
        }))
    }
}
